import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import CategorySection from "./components/CategorySection";
import CtaBanner from "./components/CtaBanner";
import ValueSection from "./components/ValueSection";
import FeaturedSection from "./components/FeaturedSection";
import InfoCards from "./components/InfoCards";
import ArticleTeaser from "./components/ArticleTeaser";
import PillarArticlesSection from "./components/PillarArticlesSection";
import JsonLd from "@/components/feature/JsonLd";
import { websiteJsonLd } from "@/lib/seo";

export default function Home() {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [hash]);

  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd data={websiteJsonLd()} />
      <Navbar />
      <main>
        <Hero />
        <CategorySection />
        <CtaBanner />
        <ValueSection />
        <FeaturedSection />
        <InfoCards />
        <ArticleTeaser />
        <PillarArticlesSection />
      </main>
      <Footer />
    </div>
  );
}